var map = {
	"./apple_maps.svg": 848,
	"./aqua.svg": 849,
	"./architecture.svg": 850,
	"./assassins_creed.svg": 851,
	"./avocado_world.svg": 852,
	"./black.svg": 853,
	"./blue.svg": 854,
	"./blue_neon.svg": 855,
	"./boston.svg": 856,
	"./bright_colors.svg": 857,
	"./classic.svg": 858,
	"./dark.svg": 859,
	"./dinosaur.svg": 860,
	"./ease.svg": 861,
	"./flat_map.svg": 862,
	"./glow.svg": 863,
	"./gray.svg": 864,
	"./grayscale_style.svg": 865,
	"./hoogeland.svg": 866,
	"./hopper.svg": 867,
	"./interface.svg": 868,
	"./invert.svg": 869,
	"./london.svg": 870,
	"./mono.svg": 871,
	"./navy_blue.svg": 872,
	"./nightlife.svg": 873,
	"./pale_dawn.svg": 874,
	"./pedro.svg": 875,
	"./red.svg": 876,
	"./retro.svg": 877,
	"./shades_of_grey.svg": 878,
	"./singapore.svg": 879,
	"./subtle_grayscale.svg": 880,
	"./thin.svg": 881,
	"./ultra_light_with_labels.svg": 882,
	"./vector.svg": 883,
	"./vibrant.svg": 884,
	"./vintage.svg": 885,
	"./vintage_golden_brown.svg": 886,
	"./warm.svg": 887,
	"./wy.svg": 888
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1417;